import { render, staticRenderFns } from "./u-image.vue?vue&type=template&id=4884d416&scoped=true"
import script from "./u-image.vue?vue&type=script&lang=js"
export * from "./u-image.vue?vue&type=script&lang=js"
import style0 from "./u-image.vue?vue&type=style&index=0&id=4884d416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884d416",
  null
  
)

export default component.exports